export enum DateFormats {
  Date = 'dd/MM/yyyy',
  Time = 'HH:mm',
  FullTime = 'HH:mm:ss',
  DateTime = 'dd/MM/yyyy - HH:mm',
  DateFullTime = 'dd/MM/yyyy - HH:mm:ss',
  DateFullTime2 = 'DD/MM/yyyy - HH:mm:ss',
  ISODate = 'yyyy-MM-dd',
  ISOFile = "dd-MM-yyyy'T'HH-mm-ss",
  ISODateTwoDots = "dd-MM-yyyy'T'HH:mm:ss",
  Evento = "EEEE, dd 'de' MMMM 'de' yyyy",
}
